(function(){var __unbxdDefine=typeof define==="function"?define:null,__unbxdAmd=__unbxdDefine&&__unbxdDefine.amd;try{if(__unbxdDefine){__unbxdDefine.amd=undefined;}!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).AutosuggestSDK={})}(this,function(t){"use strict";class e{constructor(){this.state={query:"",response:{initialRequestProducts:[],products:[],trendingSearches:[],popularProducts:[],inFields:[],keywordSuggestions:[],promotedSuggestions:[],topSearchQueries:[],prefetchedSearchResults:{}},dom:{inputBox:null,autosuggestionBox:null}}}getState(t){if(!t)return this.state;const e=t.split(".");let s=this.state;for(const t of e)s=s?.[t];return s}updateState(t,e,s=this.state){try{let o=t.split("__"),n=o[0],r=o.slice(1),i={...s};return Object.entries(s).forEach(([t,s])=>{t===n&&(o.length>1?i[t]=this.updateState(r.join("__"),e,s):i[t]=e)}),s===this.state?(this.state=i,this.state):(console.log("StateManager updateState newState",i),i)}catch(t){throw console.error("StateManager updateState error",t),t}}}const s={siteKey:"",apiKey:"",inputBoxConfigs:{searchInput:null,debounceDelay:0,minChars:3},suggestionBoxConfigs:{containerTag:"div",attributes:{class:"unx-autosuggest-box"},template:null},apiConfigs:{apiEndpoint:"https://search.unbxd.io",initialRequest:!1,inFields:{count:2},popularProducts:{count:3,fields:[]},keywordSuggestions:{count:2},topQueries:{count:2},promotedSuggestions:{count:2},trendingSearches:{count:5},search:{prefetch:!1,filterField:""}},onEvent:function({eventType:t}){console.log(`Unbxd Running onEvent with ${t}`)}},o=(t,e)=>{if(!e||0===Object.keys(e).length)return t;if(!t||0===Object.keys(t).length)return e;let s={};return Object.entries(t).forEach(([n,r])=>{s[n]="object"==typeof r&&null!==r?"attributes"===n?{...t[n],...e[n]}:o(t[n],e[n]):e[n]??r}),s};class n{constructor({configs:t}){this.configs=o(s,t)}getConfigs(t){if(!t)return this.configs;const e=t.split(".");let s=this.configs;for(const t of e)s=s?.[t];return s}isRequired(t){return["siteKey","apiKey","searchInput"].includes(t)}updateConfigs(t){this.configs=o(s,t)}}const r="BEFORE_TRENDING_SEARCHES_API_CALL",i="AFTER_TRENDING_SEARCHES_API_CALL",u="BEFORE_AUTOSUGGEST_API_CALL",a="AFTER_AUTOSUGGEST_API_CALL",g="AUTOSUGGEST_QUERY_UPDATED",c="INPUT_FOCUS",h="INPUT_BLUR",l="ERROR";class d{constructor({configurations:t={},setState:e=()=>{},getState:s=()=>{},onAutosuggestionRequest:o=()=>{},onSearchRequest:n=()=>Promise.resolve(),renderSuggestions:r=()=>{},renderPopularProductsOnly:i=()=>{},clearSuggestions:u=()=>{}}){this.configs=t,this.localState={configs:t,inputBox:null,autosuggestionBox:null,lastHoveredSuggestionValue:void 0},this.utilities={setState:e,getState:s,clearSuggestions:u,onAutosuggestionRequest:o,onSearchRequest:n,renderSuggestions:r,renderPopularProductsOnly:i},this.setState=e,this.getState=s,this.onAutosuggestionRequest=o,this.onSearchRequest=n,this.renderSuggestions=r,this.renderPopularProductsOnly=i,this.clearSuggestions=u,this._lastHoveredSuggestionValue=void 0;const a=this.configs?.inputBoxConfigs?.debounceDelay??0;this.debouncedAutosuggestRequest=a>0?function(t,e){let s;return function(...o){clearTimeout(s),s=setTimeout(()=>{t.apply(this,o)},e)}}(t=>this.onAutosuggestionRequest(t),a):null,this.initializeDOM(),this.attachAutosuggestEvents()}initializeDOM(){try{this.inputBox=document.querySelector(this.configs?.inputBoxConfigs?.searchInput)||null,this.autosuggestionBox=this.createAutosuggestionBox(),this.setState("dom__inputBox",this.inputBox),this.setState("dom__autosuggestionBox",this.autosuggestionBox)}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService initializeDOM error",t)}}createAutosuggestionBox(){try{let t=this.configs?.suggestionBoxConfigs?.containerTag,e={...this.configs?.suggestionBoxConfigs?.attributes||{}},s=document.createElement(t);return Object.entries(e).forEach(([t,e])=>{const o=Array.isArray(e)?e.join(" "):e;s.setAttribute(t,o)}),s}catch(t){return this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService createAutosuggestionBox error",t),null}}getEventsToBeAttached(){return[{target:this.inputBox,action:"input",handler:this.onInputChange.bind(this)},{target:this.inputBox,action:"focus",handler:this.onInputFocus.bind(this)},{target:this.inputBox,action:"blur",handler:this.onInputBlur.bind(this)},{target:document,action:"click",handler:this.onDocumentClick.bind(this)},{target:this.autosuggestionBox,action:"mouseover",handler:this.onAutosuggestionBoxHover.bind(this)},{target:this.inputBox,action:"keydown",handler:this.onInputKeyDown.bind(this)}]}attachAutosuggestEvents(){try{this.getEventsToBeAttached().forEach(t=>{let{target:e,action:s,handler:o}=t;e&&e.addEventListener(s,o)})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService attachEvents error",t)}}onInputChange(t){try{let e=(t.target.value||"")?.trim();const{query:s}=this.getState()||{};if(e===s)return;this.setState("query",e),this.configs?.onEvent?.({eventType:g,query:e});const{minChars:o}=this.configs?.inputBoxConfigs||{};if(0===e.length||e.length<o)return this.clearSuggestions(),void this.unmountAutosuggestionBox();this.debouncedAutosuggestRequest?this.debouncedAutosuggestRequest({query:e}):this.onAutosuggestionRequest({query:e})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onInputChange error",t)}}onInputFocus(t){try{this.configs?.onEvent?.({eventType:c}),this.setState("query",(t.target.value||"")?.trim()),this.renderSuggestions()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onInputFocus error",t)}}onInputBlur(){try{this.configs?.onEvent?.({eventType:h}),this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error(t)}}onDocumentClick(t){try{const e=t.target,s=this.inputBox&&this.inputBox.contains(e),o=this.autosuggestionBox&&this.autosuggestionBox.contains(e);s||o||this.autosuggestionBox&&this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onDocumentClick error",t)}}onInputKeyDown(t){try{"Enter"===t.key&&this.unmountAutosuggestionBox()}catch(t){console.error("onInputKeyDown error",t)}}async onAutosuggestionBoxHover(t){try{const{target:e}=t,s=["infield_suggestion","keyword_suggestion","promoted_suggestion","top_search_query"];if(!e.classList.contains("unx-item")||!s.includes(e.dataset.doctype))return;const o=e.dataset.value;if(o===this._lastHoveredSuggestionValue)return;this._lastHoveredSuggestionValue=o;const n=this.getState("response.prefetchedSearchResults")||{},r=this.configs?.apiConfigs?.search?.prefetch??!1;if(void 0!==n[o])return this.setState("response__popularProducts",n[o]??[]),void this.renderPopularProductsOnly();if(!r){const t=o.indexOf(":"),e=t>=0?o.slice(0,t):o,s=t>=0?o.slice(t+1):null;await this.onSearchRequest({query:e,filters:s?[s]:[]})}const i=this.getState("response.prefetchedSearchResults")||{};this.setState("response__popularProducts",i[o]??[]),this.renderPopularProductsOnly()}catch(t){console.error("onAutosuggestionBoxHover error",t)}}updateSuggestionBoxHTML(t=""){try{this.autosuggestionBox.innerHTML=t}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("updateSuggestionBoxHTML error",t)}}updatePopularProductsSection(t=""){try{const e=this.autosuggestionBox?.querySelector(".unx-popular-products");e&&(e.innerHTML=t)}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("updatePopularProductsSection error",t)}}mountAutosuggestionBox(){try{""!==this.autosuggestionBox?.innerHTML?.trim()?this.inputBox.after(this.autosuggestionBox):this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("mountAutosuggestionBox error",t)}}unmountAutosuggestionBox(){try{this.autosuggestionBox.remove()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("unmountAutosuggestionBox error",t)}}}class p{constructor({configurations:t,setState:e,getState:s}){this.configs=t,this.setState=e,this.getState=s||(()=>({})),this.fireInitialRequest()}fireInitialRequest(){const t=this.configs?.apiConfigs?.initialRequest,e=this.configs?.apiConfigs?.trendingSearches?.count;t&&this.fireAutosuggestRequest({query:"*",initialCall:!0}),e>0&&this.fireTrendingSearchesRequest()}buildAutosuggestURL({query:t}){try{const{siteKey:e,apiKey:s,apiConfigs:{apiEndpoint:o,inFields:n,popularProducts:r,keywordSuggestions:i,topQueries:u,promotedSuggestions:a}={}}=this.configs||{};let g=new URL(`${o}/`);return g+=`${s}/${e}/autosuggest?q=${t}&version=V2&inFields.count=${n?.count}&keywordSuggestions.count=${i?.count}&popularProducts.count=${r?.count}`+(r?.fields?.length>0?`&popularProducts.fields=${r.fields.join(",")}`:"")+`&topQueries.count=${u?.count}`+`&promotedSuggestions.count=${a?.count}`,g}catch(t){throw console.error("APIService buildAutosuggestURL error",t),t}}buildTrendingSearchesURL(){try{const{siteKey:t,apiKey:e,apiConfigs:{apiEndpoint:s}={}}=this.configs||{};return new URL(`${s}/${e}/${t}/autosuggest?trending-queries=true&q=*`)}catch(t){throw console.error("APIService buildTrendingSearchesURL error",t),t}}buildSearchUrl({query:t,filter:e=""}){const{siteKey:s,apiKey:o,apiConfigs:{popularProducts:n}}=this.configs||{},r=`https://search.unbxd.io/${o}/${s}/search?q=${encodeURIComponent(t)}&rows=${n?.count}&indent=off&facet=off&analytics=false&redirect=false${n?.fields?.length>0?`&fields=${n.fields.join(",")}`:""}`;return e?`${r}& filter=${encodeURIComponent(e)} `:r}async request(t="AUTOSUGGEST",e={}){try{let s="SEARCH"===t?this.buildSearchUrl(e):"TRENDING_SEARCHES"===t?this.buildTrendingSearchesURL():this.buildAutosuggestURL(e);const o=await fetch(s,{method:"GET"});return await o.json()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("Unbxd Autosuggest APIService request error",t)}}async fireTrendingSearchesRequest(){try{if(this.configs?.apiConfigs?.trendingSearches?.count<=0)return;this.configs?.onEvent?.({eventType:r});const t=await this.request("TRENDING_SEARCHES");if(this.configs?.onEvent?.({eventType:i}),t?.response?.products){const e=this.configs?.apiConfigs?.trendingSearches?.count;this.setState("response__trendingSearches",t.response.products.slice(0,e))}}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("setupTrendingSearches error",t)}}async fireAutosuggestRequest({query:t,initialCall:e=!1}){try{this.configs?.onEvent?.({eventType:u,query:t});const s=await this.request("AUTOSUGGEST",{query:t})||{};if(this.configs?.onEvent?.({eventType:a,query:t}),s?.response?.products)if(e)this.setState("response__initialRequestProducts",s?.response?.products||[]);else{const t=(t=>{try{let e={};return(Array.isArray(t)?t:[]).forEach(t=>{e[t?.doctype]?e[t?.doctype].push(t):e[t?.doctype]=[t]}),e}catch(t){return console.error("getSortedProducts error",t),{}}})(s?.response?.products);this.setState("response__products",s?.response?.products),this.setState("response__popularProducts",t?.POPULAR_PRODUCTS),this.setState("response__inFields",t?.IN_FIELD),this.setState("response__keywordSuggestions",t?.KEYWORD_SUGGESTION),this.setState("response__promotedSuggestions",t?.PROMOTED_SUGGESTION),this.setState("response__topSearchQueries",t?.TOP_SEARCH_QUERIES)}}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("setupAutosuggest error",t)}}async fireSearchRequest({query:t,filters:e=[]}){try{const s=await this.request("SEARCH",{query:t}),o={};if(o[t]=s.response.products,e.length>0){const s=this.configs?.apiConfigs?.search?.filterField,n=e.map(e=>this.request("SEARCH",{query:t,filter:`${s}: "${e}"`})),r=await Promise.all(n),i={...o};r.forEach((s,o)=>{i[`${t}:${e[o]} `]=s.response.products}),this.setState("response__prefetchedSearchResults",{...this.getState("response.prefetchedSearchResults"),...i})}this.setState("response__prefetchedSearchResults",{...this.getState("response.prefetchedSearchResults"),...o})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("fireSearchRequest error",t)}}}function S({IN_FIELD:t=[]}){if(0===t.length)return"";return`<div class="unx-infield-suggestions">${t.map(t=>{const e=t[this.configurations.apiConfigs.search.filterField+"_in"];let s="";return e?.length>0&&(s=`${e.map(e=>`<span class="unx-item" data-doctype="infield_suggestion" data-value="${t}:${e}">In ${e}</span>`).join("\n")}`),`<div class="unx-item unx-infield-suggestion" data-doctype="infield_suggestion" data-value="${t.autosuggest}">${t.autosuggest}${s?" "+s:""}</div>`}).join("")}</div>`}function f({KEYWORD_SUGGESTION:t=[]}){if(0===t.length)return"";return`<div class="unx-keyword-suggestions">${t.map(t=>`<div class="unx-item unx-keyword-suggestion" data-doctype="keyword_suggestion" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function y({POPULAR_PRODUCTS:t=[]}){if(0===t.length)return"";return`<div class="unx-popular-products">${t.map(t=>`<div class="unx-item unx-popular-product"><img src="${t.imageUrl}"/><div>${t.title}</div><div>${t.price}</div></div>`).join("")}</div>`}function v({PROMOTED_SUGGESTIONS:t=[]}){if(0===t.length)return"";return`<div class="unx-promoted-suggestions">${t.map(t=>`<div class="unx-item unx-promoted-suggestion" data-doctype="promoted_suggestion" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function m({TOP_SEARCHES:t=[]}){if(0===t.length)return"";return`<div class="unx-top-search-queries">${t.map(t=>`<div class="unx-item unx-top-search-query" data-doctype="top_search_query" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function E({TRENDING_SEARCHES:t=[]}){if(0===t.length)return"";return`<div class="unx-trending-searches">${t.map(t=>`<div class="unx-item unx-trending-search">${t.autosuggest}</div>`).join("")}</div>`}class T{constructor({configurations:t,getState:e}){this.configurations=t,this.getState=e,this.templates={popularProducts:y,inFields:S,keywordSuggestions:f,promotedSuggestions:v,topSearchQueries:m,trendingSearches:E},this.templates.autosuggestionBox=this.configurations?.suggestionBoxConfigs?.template?.bind(this)||this.AutosuggestionBoxTemplate.bind(this)}getTemplate(t){return this.templates[t]}AutosuggestionBoxTemplate(){try{const{query:t,response:{trendingSearches:e=[],popularProducts:s=[],keywordSuggestions:o=[],promotedSuggestions:n=[],topSearchQueries:r=[],inFields:i=[],products:u=[]}={}}=this.getState()||{};if((!t||0==t.trim().length)&&e?.length>0){return this.getTemplate("trendingSearches").call(this,{TRENDING_SEARCHES:e})}const a=s?.length>0?this.getTemplate("popularProducts")({POPULAR_PRODUCTS:s}):"",g=i?.length>0?this.getTemplate("inFields").call(this,{IN_FIELD:i}):"",c=o?.length>0?this.getTemplate("keywordSuggestions")({KEYWORD_SUGGESTION:o}):"",h=n?.length>0?this.getTemplate("promotedSuggestions")({PROMOTED_SUGGESTIONS:n}):"",l=r?.length>0?this.getTemplate("topSearchQueries")({TOP_SEARCHES:r}):"";return`${a}<div class="unx-suggestions">${g}${c}${h}${l}</div>`}catch(t){return console.error("TemplateService AutosuggestionBoxTemplate error",t),""}}constructTrendingSearchesTemplate(){try{const t=this.getState(),{response:{trendingSearches:e}={}}=t||{};return this.getTemplate("trendingSearches").call(this,{TRENDING_SEARCHES:e})}catch(t){return console.error("TemplateService constructTrendingSearchesTemplate error",t),""}}}t.Autosuggest=class{constructor(t){try{this.stateManager=new e,this.configManager=new n({configs:t});const s=this.configManager.getConfigs();this.apiService=new p({configurations:s,setState:this.stateManager.updateState.bind(this.stateManager),getState:this.stateManager.getState.bind(this.stateManager)}),this.templateService=new T({configurations:s,getState:this.stateManager.getState.bind(this.stateManager)}),this.domService=new d({configurations:s,getState:this.stateManager.getState.bind(this.stateManager),setState:this.stateManager.updateState.bind(this.stateManager),onAutosuggestionRequest:this.setupAutosuggestion.bind(this),onSearchRequest:this.fireSearchOnHover.bind(this),renderSuggestions:this.renderSuggestions.bind(this),renderPopularProductsOnly:this.renderPopularProductsOnly.bind(this),clearSuggestions:this.clearSuggestions.bind(this)})}catch(t){console.error("Autosuggest constructor error",t)}}fireSearchOnHover({query:t,filters:e=[]}){return this.apiService.fireSearchRequest({query:t,filters:e})}async setupAutosuggestion({query:t}){try{if(await this.apiService.fireAutosuggestRequest({query:t}),this.renderSuggestions(),this.configManager.getConfigs("apiConfigs.search.prefetch")){const{response:{inFields:t=[],keywordSuggestions:e=[],promotedSuggestions:s=[],topSearchQueries:o=[]}={}}=this.stateManager.getState()||{};[...t,...e,...s,...o].map(t=>{const{autosuggest:e,[this.configManager.getConfigs("apiConfigs.search.filterField")+"_in"]:s}=t;this.apiService.fireSearchRequest({query:e,...s?{filters:s}:{}})})}}catch(t){console.error("handleAutosuggestRequest error",t)}}renderSuggestions(){try{const{query:t="",response:{trendingSearches:e=[],initialRequestProducts:s=[],products:o=[]}={}}=this.stateManager.getState(),n=!t||0===t.trim().length;if(n&&0===e?.length&&0===s?.length||t?.length>0&&(o?.length??0)<=0)return void this.domService.unmountAutosuggestionBox();const r=this.templateService.getTemplate("autosuggestionBox")(this.stateManager.getState());this.domService.updateSuggestionBoxHTML(r),this.domService.mountAutosuggestionBox()}catch(t){console.error("Autosuggest renderSuggestions error",t)}}renderPopularProductsOnly(){try{const{response:{popularProducts:t=[]}={}}=this.stateManager.getState()||{},e=this.templateService.getTemplate("popularProducts")({POPULAR_PRODUCTS:t});this.domService.updatePopularProductsSection(e)}catch(t){console.error("Autosuggest renderPopularProductsOnly error",t)}}clearSuggestions(){try{this.stateManager.updateState("response__products",[]),this.stateManager.updateState("response__popularProducts",[]),this.stateManager.updateState("response__inFields",[]),this.stateManager.updateState("response__keywordSuggestions",[]),this.stateManager.updateState("response__promotedSuggestions",[]),this.stateManager.updateState("response__topSearchQueries",[])}catch(t){console.error("Autosuggest clearSuggestions error",t)}}}});
}finally{if(__unbxdDefine){__unbxdDefine.amd=__unbxdAmd;}}})();

function getSiteName() {
    return "ss-unbxd-guk-prod-timberland90101790077833"
}
function getAPIKey() {
    return "9b012539864794cf57736f2873abe80c"
}
/*
 * Timberland Africa (Shopify "Horizon" theme) - Unbxd Autosuggest (Autosuggest SDK v1.1.x)
 *
 * Replaces the theme's native predictive search (Shopify /search/suggest) that lives inside the search
 * modal (#search-modal). The modal, its input and the Clear / Close buttons are the theme's own markup
 * (see theme-changes/snippets/search-modal.liquid); the results area is drawn from Unbxd with the theme's
 * own result classes (resource-card, pills__pill, predictive-search-results__*), laid out like the
 * Unique Vintage autosuggest:
 *
 *   empty input : Popular Searches (top searches / keyword suggestion chips) | Recently viewed | Popular Products
 *   typing      : Suggestion chips | Products | Collections (in-field suggestions) | sticky "View all"
 *                 (no recently viewed, same as production)
 *
 * Flow: initAutosuggestWithRetry() -> initAutosuggest() -> asPrepareShell() (find / prepare the modal) ->
 * new Autosuggest(...) (SDK does the requests + state) -> asRender() draws buildAutosuggestTemplate(state).
 *
 * This bundle loads on every page, next to the search bundle, so every top-level name here is
 * prefixed (as* / AS_*) to avoid colliding with the search bundle's globals.
 */
const AS_CONFIG = {
    popularProducts: 4, // product cards when the input is empty
    typedProducts: 8, // product cards while typing
    popularSearches: 8, // chips when the input is empty
    suggestions: 6, // chips while typing
    collections: 5, // in-field suggestions shown as "Collections" cards while typing (inFields.count)
    collectionImages: 4, // product thumbnails per collection card, as in the theme's card
    recentlyViewed: 4, // cards shown
    recentlyViewedStored: 12,
};
// Added to every request: one result per Shopify product (variants=true) and promotion=true, which turns on the
// promotion engine so out-of-stock products are buried instead of surfaced
const AS_REQUEST_PARAMS = "&variants=true&promotion=true";
const AS_MODAL_SELECTOR = "#search-modal"; // the theme's search dialog
const AS_INPUT_SELECTOR = "#search-modal input.search-input";
const AS_RECENTLY_VIEWED_KEY = "unbxRecentlyViewed"; // localStorage key (same key the Unique Vintage integration uses)
// Fields requested for product cards. `doctype` is required: it is how products are told apart from suggestions.
const AS_PRODUCT_FIELDS = ["title", "uniqueId", "id", "handle", "imageUrl", "productUrl", "price", "compareAtPrice", "doctype"];
const AS_IMAGE_WIDTHS = [240, 352]; // srcset widths, same as the theme's native search cards

let asInstance = null; // the Autosuggest SDK instance (also exposed as window.unbxdAutosuggest for debugging)
let asContentEl = null; // results container inside the modal
let asInputEl = null; // the modal's search input
let asNavIndex = -1; // arrow-key selection (-1 = none)
let asTypedValue = ""; // what the shopper typed, restored when arrow-key selection is cancelled
let asFallback = { query: "", products: [], pending: "" }; // search-API products when autosuggest has none
let asShellSwapped = false; // true when the native component had to be swapped at runtime
let asCollectionPending = {}; // queries whose search request is in flight
let asCollectionResults = {}; // query -> { products, total } from the search API (same request the SRP makes)
let asHoverQuery = ""; // suggestion currently hovered: its search results replace the product cards

/* ---------- helpers ---------- */

// Escapes text/attribute values before they are concatenated into the HTML strings below
function asEscape(value) {
    return String(value === undefined || value === null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

// "R 4,999.00" - same format the theme prints
function asMoney(amount) {
    const number = Number(amount);
    return isNaN(number) ? "" : "R " + number.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// imageUrl comes back as an array in the feed
function asFirst(value) {
    return Array.isArray(value) ? value[0] : value;
}

// Same image optimisation as the theme: store-domain CDN path with `&width=`
function asThemeImage(url, width) {
    const src = asFirst(url);
    if (!src) {
        return "";
    }
    const match = String(src).match(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/1\/\d+\/\d+\/\d+\/(.+)$/);
    let path = match ? "//" + window.location.host + "/cdn/shop/" + match[1] : String(src);
    path = path.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
    return path + (path.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
}

// The SDK exposes its class as window.Autosuggest or window.AutosuggestSDK.Autosuggest depending on how it was bundled
function getAutosuggestConstructor() {
    return (
        (typeof window.Autosuggest === "function" && window.Autosuggest) ||
        (window.AutosuggestSDK && typeof window.AutosuggestSDK.Autosuggest === "function" && window.AutosuggestSDK.Autosuggest) ||
        null
    );
}

// Same URL the theme's own search form submits: /search?q=<query>&options[prefix]=last
function asSearchUrl(query) {
    return "/search?q=" + encodeURIComponent(query).replace(/%20/g, "+") + "&options%5Bprefix%5D=last";
}

/* ---------- recently viewed (stored in localStorage, captured on product pages) ---------- */

// Recently viewed products: [{ title, imageUrl, productUrl, price, compareAtPrice? }], newest first
function asReadRecentlyViewed() {
    try {
        const list = JSON.parse(localStorage.getItem(AS_RECENTLY_VIEWED_KEY));
        return Array.isArray(list) ? list : [];
    } catch (e) {
        return [];
    }
}

function asWriteRecentlyViewed(list) {
    try {
        localStorage.setItem(AS_RECENTLY_VIEWED_KEY, JSON.stringify(list));
    } catch (e) {
        /* storage unavailable (private mode) - recently viewed simply stays empty */
    }
}

// Reads a <meta> tag value (og:title etc.) from the current page
function asMetaContent(selector) {
    const el = document.querySelector(selector);
    return el ? el.getAttribute("content") || "" : "";
}

// On a product page remember the product so it can be offered in the search modal
function asCaptureRecentlyViewed() {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!match) {
        return;
    }
    const analytics = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || {};
    const variant = (analytics.variants && analytics.variants[0]) || {};
    const title = asMetaContent('meta[property="og:title"]') || document.title;
    const imageUrl = asMetaContent('meta[property="og:image"]');
    let price = parseFloat(asMetaContent('meta[property="og:price:amount"]').replace(/,/g, ""));
    if (isNaN(price) && variant.price) {
        price = Number(variant.price) / 100; // Shopify analytics meta is in cents
    }
    if (!title || !imageUrl) {
        return;
    }
    const productUrl = "/products/" + match[1];
    const list = asReadRecentlyViewed().filter(function (item) { return item.productUrl !== productUrl; });
    list.unshift({ title: title, imageUrl: imageUrl, productUrl: productUrl, price: isNaN(price) ? null : price });
    asWriteRecentlyViewed(list.slice(0, AS_CONFIG.recentlyViewedStored));
}

/* ---------- markup (theme classes) ---------- */

// Price markup exactly as the theme's search cards print it: sale price + struck-through compare-at price when on sale
function asPriceHtml(price, compareAt) {
    const onSale = Number(compareAt) > Number(price);
    if (onSale) {
        return (
            '<span class="price-item__group price-item--regular compare-at-price" style="color: #808080;font-weight: 400; font-size: 100%;"><span class="visually-hidden">Regular price&nbsp;</span>' +
            asEscape(asMoney(compareAt)) + "</span> " +
            '<span class="price-item__group price" style="color: #e42e2e;font-weight: 700; font-size: 100%;"><span class="visually-hidden">Sale price&nbsp;</span> ' +
            asEscape(asMoney(price)) + " </span>"
        );
    }
    return price === null || price === undefined || price === "" ? "" : '<span class="price" style="">' + asEscape(asMoney(price)) + "</span>";
}

// Analytics. The autosuggest events are sent from this file (not by the analytics V2 config): choosing a suggestion
// sends Unbxd.track("search", { query, autosuggestParams }). Each selectable link carries its own details in data-unx-as
// (JSON); asTrackSelection reads it on click. Enter on a highlighted item clicks that link, so keyboard selection is
// covered by the same path. doctype is always the API's own value, unchanged.
//   query chips / collections : { type: doctype, value: suggestion, rank, fieldName?, fieldValue? }
//   products                  : { type: POPULAR_PRODUCTS | POPULAR_PRODUCTS_FILTERED, value: title, pid, rank, src: query shown for }
//                               (a product also sends a "click" event with its pid and rank)
function asTrackAttrs(info) {
    return ' data-unx-as="' + asEscape(JSON.stringify(info)) + '"';
}

// In-field suggestion docs describe their filter through "<field>_in" arrays; source_unbxd_fields lists the fields it was built from
function asInFieldFilter(doc) {
    const fields = Array.isArray(doc.source_unbxd_fields) ? doc.source_unbxd_fields : [];
    for (let i = 0; i < fields.length; i++) {
        const values = doc[fields[i] + "_in"];
        if (Array.isArray(values) && values.length) {
            return { fieldName: fields[i], fieldValue: values[0] };
        }
    }
    return {};
}

function asTrackSelection(link) {
    const raw = link.getAttribute("data-unx-as");
    if (!raw || !window.Unbxd || typeof window.Unbxd.track !== "function") {
        return;
    }
    try {
        const info = JSON.parse(raw);
        const params = {
            autosuggest_type: info.type,
            autosuggest_suggestion: info.value,
            unbxdprank: info.rank,
            internal_query: asTypedValue.trim() || "*", // what was typed ("*" in the empty state)
        };
        if (info.fieldName) { params.field_name = info.fieldName; }
        if (info.fieldValue) { params.field_value = info.fieldValue; }
        if (info.src) { params.src_field = info.src; }
        if (info.pid) { params.pid = String(info.pid); }
        window.Unbxd.track("search", { query: info.value, autosuggestParams: params });
        // A product also counts as a product click (pid + position), sent after the search event so it carries the same query
        if (info.pid) {
            window.Unbxd.track("click", { pid: String(info.pid), prank: info.rank });
        }
    } catch (e) {
        /* analytics must never block navigation */
    }
}

// One product card (theme's resource-card markup). Works for Unbxd docs and for recently viewed entries.
// `query` is the typed text (empty in the default state), or the hovered suggestion when `filtered` is true
// (POPULAR_PRODUCTS_FILTERED). Recently viewed entries pass `tracked = false`: they are not autosuggest results, so
// they carry no analytics data.
function asProductCard(product, index, query, tracked, filtered) {
    const title = product.title || "";
    const href = product.productUrl || (product.handle ? "/products/" + product.handle : "");
    const image = asThemeImage(product.imageUrl, 500);
    if (!href || !title) {
        return "";
    }
    const srcset = image
        ? AS_IMAGE_WIDTHS.map(function (width) { return asEscape(asThemeImage(product.imageUrl, width)) + " " + width + "w"; }).join(", ")
        : "";
    return (
        '<li class="predictive-search-results__card predictive-search-results__card--product" ref="resultsItems[]">' +
        '<div class="resource-card" data-resource-type="product">' +
        '<a class="resource-card__link" href="' + asEscape(href) + '" data-unx-nav="1"' +
        (tracked
            ? asTrackAttrs({ type: filtered ? "POPULAR_PRODUCTS_FILTERED" : product.doctype || "POPULAR_PRODUCTS", value: title, pid: product.uniqueId, rank: index + 1, src: query })
            : "") + '><span class="visually-hidden"> ' + asEscape(title) + " </span></a>" +
        '<div class="resource-card__media" style="--resource-card-aspect-ratio: 4 / 5;">' +
        (image
            ? '<img src="' + asEscape(image) + '" alt="' + asEscape(title) + '" srcset="' + srcset + '" width="500" height="500" loading="lazy" class="resource-card__image" sizes="auto">'
            : "") +
        "</div>" +
        '<div class="resource-card__content"><p class="resource-card__title paragraph">' + asEscape(title) + "</p>" +
        "<div>" + asPriceHtml(product.price, product.compareAtPrice) + "</div></div></div></li>"
    );
}

// Titled row of product cards. `extraHeader` is optional HTML placed in the title (e.g. a Clear button).
function asProductsSection(title, products, extraHeader, query, tracked, limit) {
    const cards = products
        .map(function (product, index) { return asProductCard(product, index, query, tracked); })
        .join("");
    if (!cards) {
        return "";
    }
    return (
        '<div class="unbxd-as-section"><h4 class="predictive-search-results__title">' + asEscape(title) + (extraHeader || "") + "</h4>" +
        '<ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled"' +
        (tracked ? ' data-unx-products="' + (limit || products.length) + '"' : "") + ">" + cards + "</ul></div>"
    );
}

// Titled (optional) horizontally scrollable row of query chips; each chip links to the search page for that query.
// `queries` is [{ query, doctype }] (see asSplitResponse); doctype feeds the analytics attributes.
function asChipsSection(title, queries) {
    const chips = queries
        .map(function (item, index) {
            const query = item.query;
            return (
                '<li class="predictive-search-results__card--query" ref="resultsItems[]"><a class="pills__pill predictive-search-results__pill" href="' +
                asEscape(asSearchUrl(query)) + '" data-unx-nav="1" data-unx-query="' + asEscape(query) + '"' +
                asTrackAttrs({ type: item.doctype, value: query, rank: index + 1 }) + '><span>' + asEscape(query) + "</span></a></li>"
            );
        })
        .join("");
    if (!chips) {
        return "";
    }
    return (
        '<div class="unbxd-as-section">' + (title ? '<h4 class="predictive-search-results__title">' + asEscape(title) + "</h4>" : "") +
        '<ul class="predictive-search-results__list predictive-search-results__wrapper predictive-search-results__wrapper-queries unbxd-as-chips list-unstyled">' +
        chips + "</ul></div>"
    );
}

/* ---------- data from the SDK state ---------- */

// The API returns one mixed list: products (no suggestion doctype) + KEYWORD_SUGGESTION / TOP_SEARCH_QUERIES ...
function asSplitResponse(docs) {
    const products = [];
    const top = [];
    const keywords = [];
    const inFields = [];
    (docs || []).forEach(function (doc) {
        const type = doc.doctype;
        if (type === "TOP_SEARCH_QUERIES" || type === "PROMOTED_SUGGESTION") {
            top.push(doc);
        } else if (type === "KEYWORD_SUGGESTION") {
            keywords.push(doc);
        } else if (type === "IN_FIELD") {
            if (doc.autosuggest) {
                inFields.push(doc);
            }
        } else if (type === "TRENDING_SEARCHES") {
            /* not used in this design */
        } else if (doc.title && (doc.productUrl || doc.handle)) {
            products.push(doc);
        }
    });
    const seen = {};
    const queries = top
        .concat(keywords)
        .map(function (doc) { return { query: doc.autosuggest, doctype: doc.doctype }; })
        .filter(function (item) {
            const key = String(item.query || "").trim().toLowerCase();
            if (!key || seen[key]) {
                return false;
            }
            seen[key] = true;
            return true;
        });
    return { products: products, queries: queries, inFields: inFields };
}

// The autosuggest index can be empty for a store (new site key / index not built yet). Rather than showing an
// empty modal, fall back to the Search API for the product cards of the typed query.
function asFetchFallbackProducts(query) {
    if (asFallback.pending === query || asFallback.query === query) {
        return;
    }
    asFallback.pending = query;
    fetch(
        "https://search.unbxd.io/" + getAPIKey() + "/" + getSiteName() + "/search?q=" + encodeURIComponent(query) +
            "&rows=" + AS_CONFIG.typedProducts + AS_REQUEST_PARAMS + "&fields=" + AS_PRODUCT_FIELDS.join(",")
    )
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (asFallback.pending !== query) {
                return;
            }
            asFallback = { query: query, products: (data.response && data.response.products) || [], pending: "" };
            asRender();
        })
        .catch(function () {
            asFallback.pending = "";
        });
}

/* ---------- Collections: in-field suggestions as the theme's collection cards ---------- */

// Search result for one in-field suggestion, or undefined until it has loaded
function asCollectionResult(query) {
    return asCollectionResults[query];
}

function asCollectionImagesHtml(query) {
    const result = asCollectionResult(query);
    const seen = {};
    return ((result && result.products) || [])
        .map(function (product) { return asFirst(product.imageUrl); })
        .filter(function (src) {
            if (!src || seen[src]) {
                return false;
            }
            seen[src] = true;
            return true;
        })
        .slice(0, AS_CONFIG.collectionImages)
        .map(function (src) {
            return (
                '<img src="' + asEscape(asThemeImage(src, 240)) + '" srcset="' +
                AS_IMAGE_WIDTHS.map(function (width) { return asEscape(asThemeImage(src, width)) + " " + width + "w"; }).join(", ") +
                '" sizes="auto" alt="" width="240" height="240" loading="lazy" class="resource-card__collection-image">'
            );
        })
        .join("");
}

// "N products": numberOfProducts of the search request for the in-field query. The in-field doc's own
// result_unbxd_double is not used - it is counted per variant when the suggestion index is built, so it does not
// match the search page (variants=true, one result per product).
function asCollectionCountHtml(query) {
    const result = asCollectionResult(query);
    if (!result || !result.total) {
        return "";
    }
    return result.total + (result.total === 1 ? " product" : " products");
}

// Updates one card in place once its search result is in (a full redraw would reset the keyboard selection).
// A suggestion whose search finds nothing is removed, so a card never leads to an empty results page.
function asFillCollectionCard(card, query) {
    const result = asCollectionResult(query);
    if (!result) {
        return;
    }
    if (!result.total) {
        const section = card.closest(".unbxd-as-collections");
        card.remove();
        if (section && !section.querySelector(".predictive-search-results__card")) {
            section.remove();
        }
        return;
    }
    card.querySelector("[data-unx-collection-media]").innerHTML = asCollectionImagesHtml(query);
    card.querySelector("[data-unx-collection-count]").textContent = asCollectionCountHtml(query);
}

// Runs the SDK's search request (apiService.request "SEARCH": same URL builder as its hover prefetch, plus
// AS_REQUEST_PARAMS) once per query and caches { products, total }. `done` is called when the result is available.
function asSearchOnce(query, done) {
    if (asCollectionResult(query)) {
        done();
        return;
    }
    if (asCollectionPending[query]) {
        asCollectionPending[query].push(done);
        return;
    }
    asCollectionPending[query] = [done];
    asInstance.apiService.request("SEARCH", { query: query }).then(function (data) {
        const response = (data && data.response) || {};
        asCollectionResults[query] = { products: response.products || [], total: Number(response.numberOfProducts) || 0 };
        const waiting = asCollectionPending[query];
        delete asCollectionPending[query];
        waiting.forEach(function (callback) { callback(); });
    });
}

// Thumbnails and product count for each in-field suggestion
function asLoadCollections(items) {
    items.forEach(function (item) {
        const query = item.autosuggest;
        asSearchOnce(query, function () {
            asContentEl.querySelectorAll("[data-unx-collection]").forEach(function (card) {
                if (card.getAttribute("data-unx-collection") === query) {
                    asFillCollectionCard(card, query);
                }
            });
        });
    });
}

/* ---------- hover: a suggestion's own results replace the product cards (the SDK's hover behaviour) ---------- */

// Swaps the cards of the product row for the search results of the hovered suggestion (same cards, same analytics
// attributes with data-src = that suggestion). Only the <ul> is touched, so the keyboard selection survives.
function asShowHoverProducts(query) {
    const list = asContentEl.querySelector("[data-unx-products]");
    const result = asCollectionResult(query);
    if (!list || !result || asHoverQuery !== query || !result.products.length) {
        return;
    }
    const limit = Number(list.getAttribute("data-unx-products")) || AS_CONFIG.popularProducts;
    list.innerHTML = result.products
        .slice(0, limit)
        .map(function (product, index) { return asProductCard(product, index, query, true, true); })
        .join("");
}

function asBindHover() {
    asContentEl.addEventListener("mouseover", function (event) {
        const chip = event.target.closest("a[data-unx-query]");
        const query = chip && chip.dataset.unxQuery;
        if (!query || query === asHoverQuery) {
            return;
        }
        asHoverQuery = query;
        asSearchOnce(query, function () { asShowHoverProducts(query); });
    });
}

// One collection card (theme's resource-card for collections: thumbnails, title, product count). Links to the
// search page for the in-field query. Thumbnails and count fill in when its search request returns.
function asCollectionCard(item, index) {
    const query = item.autosuggest;
    const result = asCollectionResult(query);
    if (result && !result.total) {
        return "";
    }
    return (
        '<li class="predictive-search-results__card" ref="resultsItems[]" data-unx-collection="' + asEscape(query) + '">' +
        '<div class="resource-card" data-resource-type="collection">' +
        '<a class="resource-card__link" href="' + asEscape(asSearchUrl(query)) + '" data-unx-nav="1"' +
        asTrackAttrs(Object.assign({ type: item.doctype, value: query, rank: index + 1 }, asInFieldFilter(item))) + '><span class="visually-hidden">' + asEscape(query) + "</span></a>" +
        '<div class="resource-card__media"><div class="resource-card__image-wrapper" data-unx-collection-media>' +
        asCollectionImagesHtml(query) + "</div></div>" +
        '<div class="resource-card__content"><p class="resource-card__title paragraph">' + asEscape(query) + "</p>" +
        '<p class="resource-card__subtext paragraph" data-unx-collection-count>' + asCollectionCountHtml(query) + "</p>" +
        "</div></div></li>"
    );
}

// "Collections" row with prev / next chevrons (they scroll the row by its visible width)
function asCollectionsSection(items) {
    if (!items.length) {
        return "";
    }
    asLoadCollections(items);
    const cards = items.map(asCollectionCard).join("");
    if (!cards) {
        return "";
    }
    const chevron = function (direction) {
        return (
            '<button type="button" class="button-unstyled unbxd-as-scroll" data-unx-scroll="' + direction + '" aria-label="' +
            (direction < 0 ? "Previous" : "Next") + '"><svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none"' +
            (direction < 0 ? ' style="transform: rotate(180deg)"' : "") +
            '><path d="M5.5 3L9.5 7L5.5 11" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        );
    };
    return (
        '<div class="unbxd-as-section unbxd-as-collections"><div class="predictive-search-results__resource-header unbxd-as-resource-header">' +
        '<h4 class="predictive-search-results__title">Collections</h4>' +
        (items.length > 1 ? '<div class="unbxd-as-scroll-controls">' + chevron(-1) + chevron(1) + "</div>" : "") +
        '</div><ul class="predictive-search-results__list predictive-search-results__wrapper list-unstyled unbxd-as-collections__list">' +
        cards + "</ul></div>"
    );
}

// Sticky "View all" button at the bottom of the results (replaces the theme's absolutely positioned footer)
function asViewAllFooter(query) {
    return (
        '<div class="unbxd-as-footer"><a class="button predictive-search__search-button" href="' + asEscape(asSearchUrl(query)) + '">View all</a></div>'
    );
}

// "Recently viewed" row with a Clear button (empty string when nothing is stored)
function asRecentlyViewedSection() {
    const viewed = asReadRecentlyViewed().slice(0, AS_CONFIG.recentlyViewed);
    return viewed.length
        ? asProductsSection(
              "Recently viewed",
              viewed,
              '<button type="button" class="button-unstyled predictive-search-results__clear unbxd-as-clear-viewed">Clear</button>'
          )
        : "";
}

/*
 * SDK template: turns the SDK state into the modal's HTML. Called from asRender() (never directly by the SDK).
 *  - empty input -> state.response.initialRequestProducts (the "*" request fired at start-up)
 *  - typed query -> state.response.products (the request for what was typed)
 * An empty string means "show nothing" (e.g. the search fallback is still loading).
 */
function buildAutosuggestTemplate(state) {
    const query = ((state && state.query) || "").trim();
    const response = (state && state.response) || {};
    if (query) {
        const typed = asSplitResponse(response.products);
        let typedProducts = typed.products;
        const fallbackDone = asFallback.query === query;
        if (!typedProducts.length) {
            if (fallbackDone) {
                typedProducts = asFallback.products;
            } else {
                asFetchFallbackProducts(query);
            }
        }
        const resultsHtml =
            asChipsSection("", typed.queries.slice(0, AS_CONFIG.suggestions)) +
            asProductsSection("Products", typedProducts.slice(0, AS_CONFIG.typedProducts), "", query, true, AS_CONFIG.typedProducts) +
            asCollectionsSection(typed.inFields.slice(0, AS_CONFIG.collections));
        if (resultsHtml) {
            return (
                '<div class="predictive-search-results__inner unbxd-as-inner" data-search-results="true">' + resultsHtml + "</div>" +
                asViewAllFooter(query)
            );
        }
        // nothing from autosuggest and the search fallback has answered -> say so; while it is loading show nothing
        if (!fallbackDone) {
            return "";
        }
        return (
            '<div class="predictive-search-results__inner unbxd-as-inner"><div class="predictive-search-results__no-results"><p>No results found for "' +
            asEscape(query) + '"</p></div></div>'
        );
    }
    // Empty input only: popular searches (chips) first, then recently viewed, then popular products
    const initial = asSplitResponse(response.initialRequestProducts);
    const html =
        asChipsSection("Popular Searches", initial.queries.slice(0, AS_CONFIG.popularSearches)) +
        asRecentlyViewedSection() +
        asProductsSection("Popular Products", initial.products.slice(0, AS_CONFIG.popularProducts), "", "", true, AS_CONFIG.popularProducts);
    return html ? '<div class="predictive-search-results__inner unbxd-as-inner" data-search-results="true">' + html + "</div>" : "";
}

// Draws the current SDK state into the results container
function asRender() {
    if (!asContentEl || !asInstance) {
        return;
    }
    asNavIndex = -1;
    asHoverQuery = "";
    asContentEl.innerHTML = buildAutosuggestTemplate(asInstance.stateManager.getState());
}

/* ---------- theme shell: swap the native predictive search for plain markup ---------- */

function asPrepareShell() {
    // Preferred: the theme's search-modal.liquid is edited so the modal is already plain markup
    // (data-unbxd-autosuggest) and the native predictive search never loads.
    let plain = document.querySelector(AS_MODAL_SELECTOR + " [data-unbxd-autosuggest]");
    if (!plain) {
        // Fallback (theme not edited): swap the native component for a plain element. It fetches Shopify's
        // /search/suggest on input and rewrites the results area, so every declarative on: handler it owned
        // is dropped. The dialog's own handlers sit on <dialog> and stay.
        const native = document.querySelector(AS_MODAL_SELECTOR + " predictive-search-component");
        if (!native) {
            return false;
        }
        plain = document.createElement("div");
        plain.className = native.className;
        plain.setAttribute("style", native.getAttribute("style") || "");
        plain.setAttribute("role", "search");
        plain.dataset.unbxdAutosuggest = "1";
        plain.innerHTML = native.innerHTML.replace(/\son:[a-z-]+="[^"]*"/gi, "");
        native.replaceWith(plain);
        asShellSwapped = true;
    }
    asContentEl = plain.querySelector(".predictive-search-form__content");
    asInputEl = plain.querySelector("input.search-input");
    if (!asContentEl || !asInputEl) {
        return false;
    }
    asContentEl.innerHTML = "";
    asContentEl.removeAttribute("ref");
    return true;
}

// Closes the theme's dialog (only needed when the native close button had to be re-wired, see asPrepareShell)
function asCloseModal() {
    const modal = document.querySelector(AS_MODAL_SELECTOR);
    if (modal && typeof modal.closeDialog === "function") {
        modal.closeDialog();
    } else {
        const dialog = modal && modal.querySelector("dialog");
        if (dialog) { dialog.close(); }
    }
}

// Shows the theme's "Clear" button only while the input has text
function asSyncResetButton() {
    const reset = document.querySelector(AS_MODAL_SELECTOR + " .predictive-search__reset-button");
    if (reset) {
        reset.hidden = !asInputEl.value;
    }
}

// Back to the default (empty input) state: clears the input and the SDK query, then redraws
function asResetSearch(keepFocus) {
    asInputEl.value = "";
    asTypedValue = "";
    asSyncResetButton();
    if (asInstance) {
        asInstance.stateManager.updateState("query", "");
    }
    asRender();
    if (keepFocus) {
        asInputEl.focus();
    }
}

// Links reachable with the arrow keys: query chips and product cards, in DOM order
function asNavItems() {
    return Array.from(asContentEl.querySelectorAll("a[data-unx-nav]"));
}

// Highlights the item at `index` (-1 clears it); a chip also writes its query into the input, like the theme's search
function asSetNav(index) {
    const items = asNavItems();
    items.forEach(function (item, i) {
        const on = i === index;
        item.closest("li, .resource-card").classList.toggle("unx-nav-active", on);
        if (on) {
            item.setAttribute("aria-selected", "true");
            item.scrollIntoView({ block: "nearest", inline: "nearest" });
        } else {
            item.removeAttribute("aria-selected");
        }
    });
    asNavIndex = index;
    if (index === -1) {
        asInputEl.value = asTypedValue;
    } else if (items[index].dataset.unxQuery) {
        asInputEl.value = items[index].dataset.unxQuery;
    }
}

// Rows of the results: chips, products and collections each sit in their own row (products wrap into several on
// desktop), so Up / Down move between rows by position instead of stepping through the list one item at a time.
function asRect(link) {
    return link.closest("li").getBoundingClientRect();
}

function asSameRow(a, b) {
    return Math.abs(asRect(a).top - asRect(b).top) < 8;
}

// Index to highlight after Down (direction 1) or Up (-1): the item in the nearest row below / above whose centre
// is closest to the current one; -1 (back to what was typed) when there is no row left in that direction
function asVerticalTarget(items, direction) {
    const current = asRect(items[asNavIndex]);
    const centre = current.left + current.width / 2;
    let rowTop = null;
    items.forEach(function (item) {
        const top = asRect(item).top;
        const inDirection = direction > 0 ? top > current.top + 8 : top < current.top - 8;
        if (inDirection && (rowTop === null || (direction > 0 ? top < rowTop : top > rowTop))) {
            rowTop = top;
        }
    });
    if (rowTop === null) {
        return -1;
    }
    let best = -1;
    let bestDistance = Infinity;
    items.forEach(function (item, index) {
        const rect = asRect(item);
        const distance = Math.abs(rect.left + rect.width / 2 - centre);
        if (Math.abs(rect.top - rowTop) < 8 && distance < bestDistance) {
            best = index;
            bestDistance = distance;
        }
    });
    return best;
}

// Listeners for the modal: typing state, arrow keys + Enter, Clear / Close buttons, Recently viewed "Clear",
// reset on close and focus on open
function asBindShellEvents() {
    const modal = document.querySelector(AS_MODAL_SELECTOR);
    asInputEl.addEventListener("input", function () {
        asTypedValue = asInputEl.value;
        asNavIndex = -1;
        asSyncResetButton();
    });
    asInputEl.addEventListener("keydown", function (event) {
        const items = asNavItems();
        const last = items.length - 1;
        if ((event.key === "ArrowDown" || event.key === "ArrowUp") && items.length) {
            event.preventDefault();
            if (asNavIndex === -1) { asTypedValue = asInputEl.value; }
            if (asNavIndex === -1) {
                asSetNav(event.key === "ArrowDown" ? 0 : last);
            } else {
                asSetNav(asVerticalTarget(items, event.key === "ArrowDown" ? 1 : -1));
            }
        } else if ((event.key === "ArrowRight" || event.key === "ArrowLeft") && asNavIndex > -1 && items[asNavIndex]) {
            // with an item highlighted, left / right move along its row (the caret only moves while nothing is highlighted)
            const next = items[asNavIndex + (event.key === "ArrowRight" ? 1 : -1)];
            if (next && asSameRow(items[asNavIndex], next)) {
                event.preventDefault();
                asSetNav(asNavIndex + (event.key === "ArrowRight" ? 1 : -1));
            }
        } else if (event.key === "Tab" && items.length) {
            // Tab / Shift+Tab walk the suggestions; past either end focus leaves the input as usual
            const forward = !event.shiftKey;
            if (forward ? asNavIndex < last : asNavIndex > -1) {
                event.preventDefault();
                if (asNavIndex === -1) { asTypedValue = asInputEl.value; }
                asSetNav(forward ? asNavIndex + 1 : asNavIndex - 1);
            }
        } else if (event.key === "Enter" && asNavIndex > -1 && items[asNavIndex]) {
            // a real click, so the analytics script records it and the browser follows the link
            event.preventDefault();
            items[asNavIndex].click();
        }
    });
    // Enter / submit with nothing typed searches for "*" (all products), as production does. Without this the form
    // would go to /search?q= and the SRP, which needs a query, would come up empty.
    const searchForm = asInputEl.form;
    if (searchForm) {
        searchForm.addEventListener("submit", function (event) {
            if (!asInputEl.value.trim()) {
                event.preventDefault();
                window.location.href = asSearchUrl("*");
            }
        });
    }
    // Analytics for a chosen suggestion / product / collection (capture: runs before navigation or any other click handler)
    asContentEl.addEventListener("click", function (event) {
        const link = event.target.closest("a[data-unx-as]");
        if (link) {
            asTrackSelection(link);
        }
    }, true);
    const reset = modal.querySelector(".predictive-search__reset-button");
    if (reset) {
        reset.addEventListener("click", function () { asResetSearch(true); });
    }
    const closeButton = modal.querySelector(".predictive-search__close-modal-button");
    if (closeButton && asShellSwapped) {
        // when the theme markup is edited, the button keeps the theme's own dialog-component/closeDialog handler
        closeButton.addEventListener("click", asCloseModal);
    }
    // In-modal controls (Collections chevrons, Recently viewed "Clear"):
    //  - mousedown is cancelled so the input keeps focus. Otherwise the click blurs it, and re-focusing it makes the
    //    SDK redraw the results (onInputFocus), which resets the row's scroll.
    //  - the click stops here: the theme's dialog-component closes the modal when the clicked element is no longer
    //    inside the dialog, which is the case after "Clear" redraws the results.
    const AS_CONTROL_SELECTOR = "[data-unx-scroll], .unbxd-as-clear-viewed";
    asContentEl.addEventListener("mousedown", function (event) {
        if (event.target.closest(AS_CONTROL_SELECTOR)) {
            event.preventDefault();
        }
    });
    asContentEl.addEventListener("click", function (event) {
        const control = event.target.closest(AS_CONTROL_SELECTOR);
        if (!control) {
            return;
        }
        event.stopPropagation();
        if (control.hasAttribute("data-unx-scroll")) {
            const list = control.closest(".unbxd-as-section").querySelector(".unbxd-as-collections__list");
            list.scrollBy({ left: Number(control.dataset.unxScroll) * list.clientWidth, behavior: "smooth" });
            return;
        }
        asWriteRecentlyViewed([]);
        asRender();
    });
    // Reset when the modal closes, focus the input when it opens
    const dialog = modal.querySelector("dialog");
    if (dialog) {
        dialog.addEventListener("close", function () { asResetSearch(false); });
        new MutationObserver(function () {
            if (dialog.open) {
                setTimeout(function () { asInputEl.focus(); }, 50);
            }
        }).observe(dialog, { attributes: true, attributeFilter: ["open"] });
    }
    asSyncResetButton();
}

/* ---------- SDK ---------- */

// Creates the SDK instance once the SDK is loaded and the modal exists. Returns true when done.
function initAutosuggest() {
    if (asInstance) {
        return true;
    }
    const Ctor = getAutosuggestConstructor();
    if (!Ctor || !document.querySelector(AS_MODAL_SELECTOR + " predictive-search-component, " + AS_MODAL_SELECTOR + " [data-unbxd-autosuggest]")) {
        return false;
    }
    if (!asPrepareShell()) {
        return false;
    }

    asInstance = new Ctor({
        siteKey: getSiteName(),
        apiKey: getAPIKey(),
        inputBoxConfigs: { searchInput: AS_INPUT_SELECTOR, debounceDelay: 200, minChars: 1 },
        suggestionBoxConfigs: { containerTag: "div", attributes: { class: "unbxd-as-box" }, template: buildAutosuggestTemplate },
        apiConfigs: {
            apiEndpoint: "https://search.unbxd.io",
            initialRequest: false, // fired below, after the URL builder is adjusted
            inFields: { count: AS_CONFIG.collections },
            popularProducts: { count: Math.max(AS_CONFIG.popularProducts, AS_CONFIG.typedProducts), fields: AS_PRODUCT_FIELDS },
            keywordSuggestions: { count: AS_CONFIG.suggestions },
            topQueries: { count: AS_CONFIG.popularSearches },
            promotedSuggestions: { count: 0 },
            trendingSearches: { count: 0 },
            search: { prefetch: false, filterField: "" },
        },
        onEvent: function (event) {
            if (event.eventType === "ERROR") {
                console.error("[Unbxd Autosuggest]", event.error);
            }
        },
    });

    // AS_REQUEST_PARAMS on the autosuggest request and on the SDK's search request (Collections thumbnails,
    // hover products)
    const buildUrl = asInstance.apiService.buildAutosuggestURL.bind(asInstance.apiService);
    asInstance.apiService.buildAutosuggestURL = function (options) {
        return buildUrl(options) + AS_REQUEST_PARAMS;
    };
    const buildSearchUrl = asInstance.apiService.buildSearchUrl.bind(asInstance.apiService);
    asInstance.apiService.buildSearchUrl = function (options) {
        return buildSearchUrl(options) + AS_REQUEST_PARAMS;
    };

    // Always draw into the modal's results area (the SDK would otherwise insert its own box after the input)
    asInstance.renderSuggestions = asRender;
    asInstance.domService.renderSuggestions = asRender;
    if (asInstance.domService.utilities) {
        asInstance.domService.utilities.renderSuggestions = asRender;
    }
    asInstance.domService.mountAutosuggestionBox = function () {};
    asInstance.domService.unmountAutosuggestionBox = function () {};

    asBindShellEvents();
    asBindHover();

    // Default state (empty input): popular products + popular searches
    asInstance.apiService.fireAutosuggestRequest({ query: "*", initialCall: true }).then(asRender, asRender);
    asRender();
    window.unbxdAutosuggest = asInstance;
    return true;
}

// Entry point: remembers the current product (if on a product page) and starts the SDK, retrying for up to ~10s
// because the SDK / modal markup may not be ready yet
function initAutosuggestWithRetry() {
    asCaptureRecentlyViewed();
    if (initAutosuggest()) {
        return;
    }
    let attempts = 0;
    const timer = setInterval(function () {
        if (initAutosuggest() || ++attempts >= 40) {
            clearInterval(timer);
        }
    }, 250);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAutosuggestWithRetry);
} else {
    initAutosuggestWithRetry();
}

/*
 * Timberland Africa (Shopify "Horizon" theme) - Unbxd Recommendations
 *
 * Bundled into the autosuggest file (loads on every page). It fills the containers the theme adds with the
 * Unbxd recommendation widgets, drawn exactly like the theme's own "product recommendations" block
 * ("More from Timberland": section-resource-list > resource-list--grid of product cards), so quick add, the
 * image slideshow and Judge.me ratings keep working.
 *
 * Containers (add one per widget; a second widget on the same page uses the _2 suffix):
 *   <div id="pdp_recommendations"></div>                                          product page   -> pageType PRODUCT
 *                                  (product id = data-product-id of the main product-form-component)
 *   <div id="cart_recommendations"></div>                                         cart page      -> pageType CART
 *   <div id="home_recommendations"></div>                                         home page      -> pageType HOME
 *   <div id="plp_recommendations"></div>                                          collection     -> pageType CATEGORY
 *
 * Search / browse with no results: the search bundle's no-results template adds <div id="srp_recommendations_1">
 * and calls window.unbxdRecsRenderNoResults(), which fills it with the HOME widgets (RC_NO_RESULTS_PATTERN).
 *
 * Flow: rcStart() -> rcFindContainers() -> rcResolveRequest() (ids for PDP / cart) -> fetch -> rcRenderWidgets().
 *
 * This bundle shares the page with the search and autosuggest bundles, so every top-level name is prefixed
 * (rc* / RC_*) to avoid collisions.
 */
const RC_CONFIG = {
    maxProducts: 4, // cards per widget, as in the theme's block (limit=4)
    fallbackTitle: "More from Timberland",
};
const RC_CONTAINER_PATTERNS = [
    { prefix: "pdp_recommendations", pageType: "PRODUCT" },
    { prefix: "cart_recommendations", pageType: "CART" },
    { prefix: "home_recommendations", pageType: "HOME" },
    { prefix: "plp_recommendations", pageType: "CATEGORY" },
];
// Rendered on demand by the search bundle (not at page load - the container only exists once a search has no results)
const RC_NO_RESULTS_PATTERN = { prefix: "srp_recommendations", pageType: "HOME" };
// Fields requested for the cards (same set the search cards use)
const RC_FIELDS = ["title", "uniqueId", "productUrl", "handle", "imageUrl", "images", "id", "availability", "price", "compareAtPrice", "meta_badge", "v_title"];
const RC_IMAGE_WIDTHS = [240, 352, 832, 1200, 1600, 1920, 2560, 3840];
const RC_IMAGE_SIZES = "(min-width: 750px) 25.0vw, 100vw"; // the theme's `sizes` for a 4-column recommendations block
const RC_MAX_SLIDES = 5; // the theme shows at most 5 slides per card
const RC_ARROW_SVG =
    '<span class="svg-wrapper icon-arrow"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>\n</span>';
const RC_QUICK_ADD_ICON =
    '<span aria-hidden="true" class="svg-wrapper add-to-cart-icon"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"/></svg>\n</span>';

/* ---------- helpers ---------- */

// Escapes text/attribute values before they are concatenated into the HTML strings below
function rcEscape(value) {
    return String(value === undefined || value === null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

// The feed returns some fields as a string, some as an array - always work with an array
function rcArray(value) {
    if (Array.isArray(value)) {
        return value;
    }
    return value ? [value] : [];
}

// "R 4,999.00" - same format the theme prints
function rcMoney(amount) {
    const number = Number(amount);
    return isNaN(number) ? "" : "R " + number.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Same image optimisation as the theme: store-domain CDN path with `&width=`
function rcThemeImage(url, width) {
    if (!url) {
        return "";
    }
    const match = String(url).match(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/1\/\d+\/\d+\/\d+\/(.+)$/);
    const path = match ? "//" + window.location.host + "/cdn/shop/" + match[1] : url;
    return path + (path.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
}

// Slide order matches the theme: featured image first, then the rest (the feed lists `images` in reverse)
function rcImages(product) {
    const featured = rcArray(product.imageUrl)[0];
    const others = rcArray(product.images).slice().reverse();
    const seen = {};
    const images = [];
    [featured].concat(others).forEach(function (src) {
        if (src && !seen[src]) {
            seen[src] = true;
            images.push(src);
        }
    });
    return images;
}

// Shopify option count from the variant title ("XXL / Dark Olive" -> 2). Theme default is 2.
function rcOptionsCount(product) {
    const variantTitle = product.v_title || "";
    return variantTitle && variantTitle !== "Default Title" ? variantTitle.split(" / ").length : 2;
}

// Unbxd visitor id from the analytics cookie (the analytics script sets it); random per page view when absent
function rcUserId() {
    const match = document.cookie.match("\\bunbxd.userId=([^;]*)\\b");
    if (match) {
        return match[1];
    }
    if (!window._unbxdRecsUid) {
        window._unbxdRecsUid = "unx-" + Math.random().toString(36).slice(2, 12);
    }
    return window._unbxdRecsUid;
}

/* ---------- card markup (theme's product-card, as rendered in the recommendations block) ---------- */

// One <img> exactly as the theme prints it. The first slide loads eagerly, the others lazily with `auto,` sizes.
function rcImage(src, alt, isFeatured) {
    const srcset = RC_IMAGE_WIDTHS.map(function (width) { return rcThemeImage(src, width) + " " + width + "w"; }).join(", ");
    const maxSrc = rcThemeImage(src, 3840);
    return (
        '<img src="' + rcEscape(maxSrc) + '" alt="' + rcEscape(alt) + '" srcset="' + rcEscape(srcset) + '" width="3840" height="3840" loading="' +
        (isFeatured ? "eager" : "lazy") + '" sizes="' + rcEscape((isFeatured ? "" : "auto, ") + RC_IMAGE_SIZES) +
        '" class="product-media__image" data_max_resolution="' + rcEscape(maxSrc) + '" fetchpriority="auto" style="--focal-point: 50.0% 50.0%;">'
    );
}

function rcMedia(src, alt, mediaId, isFeatured) {
    return '<div class="product-media" style="--ratio: 1.0" data-media-id="' + mediaId + '">' + rcImage(src, alt, isFeatured) + "</div>";
}

// Image area of the card: a single image, or the theme's <slideshow-component> (hover / swipe / arrows), plus the
// Sale / Sold out badge and the "Choose" quick-add button
function rcGallery(product, hasSale, isSoldOut) {
    const id = product.id || product.uniqueId;
    const title = product.title || "";
    const url = product.productUrl || "/products/" + product.handle;
    const images = rcImages(product);
    const slides = images.slice(0, RC_MAX_SLIDES);
    const hasBadge = hasSale || isSoldOut;
    let media = "";

    if (slides.length === 1) {
        media =
            '<div class="product-media-container media-fit product-media-container--image" style="--product-media-fit: cover;">' +
            rcMedia(slides[0], title, id + "-0", true) + "</div>";
    } else if (slides.length > 1) {
        const timeline = slides.map(function (_, i) { return "--slide-" + i; }).join(", ");
        const arrows =
            images.length > 2
                ? '<slideshow-arrows position="center"><button class="slideshow-control slideshow-control--previous slideshow-control--style-arrow button button-unstyled button-unstyled--transparent flip-x" aria-label="Previous slide" on:click="/previous" ref="previous">' +
                  RC_ARROW_SVG +
                  '</button><button class="slideshow-control slideshow-control--next slideshow-control--style-arrow button button-unstyled button-unstyled--transparent" aria-label="Next slide" on:click="/next" ref="next">' +
                  RC_ARROW_SVG + "</button></slideshow-arrows>"
                : "";
        const slideHtml = slides
            .map(function (src, i) {
                return (
                    '<slideshow-slide ref="slides[]" aria-hidden="' + (i === 0 ? "false" : "true") + '" style="--slideshow-timeline: --slide-' + i +
                    '; --product-media-fit: cover; --grid-template-rows: 50dvh 1fr; --grid-template-rows-desktop: 70dvh 1fr;" class="product-media-container media-fit product-media-container--image"' +
                    (i === 0 ? " variant-image" : "") + ' slide-id="' + id + "-" + i + '">' +
                    rcMedia(src, title, id + "-" + i, i === 0) + "</slideshow-slide>"
                );
            })
            .join("");
        media =
            '<slideshow-component ref="slideshow" style="--slideshow-timeline: ' + timeline +
            ';--slide-min-height: auto;--slide-min-height-desktop: auto;" initial-slide="0" infinite data-generic-media-size="' + (images.length - 1) +
            '"><slideshow-container ref="slideshowContainer">' + arrows + '<slideshow-slides tabindex="-1" ref="scroller">' + slideHtml +
            "</slideshow-slides></slideshow-container></slideshow-component>";
    }

    const badge = hasBadge
        ? '<div class="product-badges product-badges--top-left" style=" --badge-border-radius: 0px; --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: none; ">' +
          '<div class="product-badges__badge product-badges__badge--rectangle ' + (isSoldOut ? "color-custom-badge-sold-out" : "color-custom-badge-sale") + '">' +
          (isSoldOut ? "Sold out" : "Sale") + "</div></div>"
        : "";

    const quickAdd =
        '<quick-add-component class="quick-add custom-color-quick-add" ref="quickAdd" data-product-title="' + rcEscape(title) + '" data-product-id="' + id +
        '" data-unique-id="' + rcEscape(product.uniqueId) + '" data-quick-add-button="choose" data-product-options-count="' + rcOptionsCount(product) +
        '" data-uses-selling-plans="false" data-renders-both-buttons="">' +
        '<button class="button quick-add__button quick-add__button--choose add-to-cart-button" type="button" name="add" data-unique-id="' + rcEscape(product.uniqueId) +
        '" on:click="quick-add-component/handleClick">' + RC_QUICK_ADD_ICON + "Choose</button></quick-add-component>";

    return (
        '<div ref="cardGallery" class="card-gallery spacing-style border-style' + (hasBadge ? " card-gallery--badge-top-left" : "") +
        '" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --gallery-aspect-ratio: 1.0;" data-product-id="' +
        id + '"' + (images.length > 1 ? ' on:pointerenter="/previewImage" on:pointerleave="/resetImage"' : "") +
        ' data-view-transition-to-main-product data-image-ratio="adapt">' +
        '<a class="contents" ref="cardGalleryLink" href="' + rcEscape(url) + '" aria-label="' + rcEscape(title) + '">' + media + "</a>" + badge + quickAdd + "</div>"
    );
}

// Price block: single price, or sale price + struck-through compare-at price (same markup/order as the theme)
function rcPrice(product, hasSale) {
    const priceHtml = hasSale
        ? '<span class="price-item__group price" style="color: #e42e2e;font-weight: 700; font-size: 100%;"><span class="visually-hidden">Sale price&nbsp;</span> ' + rcMoney(product.price) + " </span> " +
          '<span class="price-item__group price-item--regular compare-at-price" style="color: #808080;font-weight: 400; font-size: 100%;"><span class="visually-hidden">Regular price&nbsp;</span>' +
          rcMoney(product.compareAtPrice) + "</span>"
        : '<span class="price" style="">' + rcMoney(product.price) + "</span>";
    return (
        '<product-price class="text-block text-block--align-left text-left h5 spacing-style" data-product-id="' + (product.id || product.uniqueId) +
        '" style="--padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --width: 100%;"><div ref="priceContainer">' +
        priceHtml + "</div></product-price>"
    );
}

// Judge.me rating badge. The feed carries the rendered badge (meta_badge); Judge.me hydrates the wrapper.
function rcReviewBadge(product) {
    return (
        '<div class="shopify-block shopify-app-block"><div class="jdgm-widget jdgm-preview-badge" data-id="' + (product.id || product.uniqueId) +
        '" data-template="manual-installation">' + (product.meta_badge || "") + "</div></div>"
    );
}

/*
 * One grid item. `idx` is the 0-based position in the widget. The data-unbxdparam_* attributes are what the
 * Unbxd analytics script reads for recommendation impressions / clicks (same contract as the Woolery integration).
 */
function rcCard(product, idx, analytics) {
    const id = product.id || product.uniqueId;
    const title = product.title || "";
    const url = product.productUrl || "/products/" + product.handle;
    const hasSale = Number(product.compareAtPrice) > Number(product.price);
    const isSoldOut = String(product.availability) === "false";
    const viewPayload = JSON.stringify({
        product: { id: Number(id), title: title, handle: product.handle, selectedVariant: null },
        context: "recommendation",
        selectedOptions: [],
    });
    return (
        '<div class="resource-list__item" data-id="' + rcEscape(product.uniqueId) + '" data-product-id="' + rcEscape(product.uniqueId) +
        '" data-prank="' + idx + '" data-unbxdparam_experience_widget="' + rcEscape(String(analytics.widgetId || "").toUpperCase()) +
        '" data-unbxdparam_experience_pagetype="' + rcEscape(analytics.pageType) + '" data-unbxdparam_sku="' + rcEscape(product.uniqueId) +
        '" data-unbxdparam_requestId="' + rcEscape(analytics.requestId) + '">' +
        '<product-card class="product-card size-style" style="--size-style-width: ;--size-style-height: ;" data-product-id="' + id +
        '" id="product-card-recs-' + id + '" data-product-transition="true" data-featured-media-url="' + rcEscape(rcThemeImage(rcImages(product)[0], 500)) +
        '" on:click="/handleViewTransition" view-event-payload="' + rcEscape(viewPayload) + '">' +
        '<a id="product-card-recs-link-' + id + '" href="' + rcEscape(url) + '" class="product-card__link" ref="productCardLink" aria-label="' + rcEscape(title) + '"></a>' +
        '<div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ; --padding-block-start: 0px;--padding-block-end: 8px;--padding-inline-start: 0px;--padding-inline-end: 0px; --product-card-gap: 8px; --quick-add-display: flex; --quick-add-mobile-display: none; --quick-add-mobile-opacity: 0; --zoom-out-padding-block-end: min(var(--padding-xs), 5.6px);">' +
        rcGallery(product, hasSale, isSoldOut) +
        '<div class="product-grid-view-zoom-out--details"><h3 class="h4">' + rcEscape(title) + "</h3></div>" +
        '<a class="contents user-select-text" ref="productTitleLink" href="' + rcEscape(url) + '">' +
        '<div class="spacing-style text-block rte text-block--align-left" style="--padding-block-start: 4px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: 100%; --max-width: var(--max-width--body-normal); --text-align: left;">' +
        '<p role="heading" aria-level="3">' + rcEscape(title) + "</p></div></a>" +
        rcReviewBadge(product) + rcPrice(product, hasSale) +
        "</div></product-card></div>"
    );
}

/* ---------- widget markup (theme's section-resource-list > resource-list--grid) ---------- */

// Widget titles come back as "Product Page - Similar items"; the theme shows only the part after the dash
function rcWidgetTitle(widget) {
    const title = String(widget.widgetTitle || "").replace(/^[^-]+-\s*/, "").trim();
    return title || RC_CONFIG.fallbackTitle;
}

function rcWidgetHtml(widget, analytics) {
    const products = (widget.recommendations || []).slice(0, RC_CONFIG.maxProducts);
    if (!products.length) {
        return "";
    }
    const cards = products.map(function (product, idx) { return rcCard(product, idx, analytics); }).join("");
    return (
        '<div class="unbxd-recs product-recommendations">' +
        '<div class="section-background"></div>' +
        '<div class="section section--page-width section-resource-list spacing-style gap-style" style="--padding-block-start: max(20px, calc(var(--spacing-scale) * 24px));--padding-block-end: max(20px, calc(var(--spacing-scale) * 24px)); --gap: max(24px, calc(var(--gap-scale, 1.0) * 28px)); --column-count-mobile: 2;--resource-list-column-gap-desktop: 12px;--resource-list-row-gap-desktop: 24px;--resource-list-columns: repeat(4, 1fr);--resource-list-columns-mobile: repeat(2, 1fr);--column-count: 4;">' +
        '<div class="section-resource-list__content"><div class="spacing-style text-block h4" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: fit-content; --max-width: var(--max-width--body-normal);">' +
        "<h3>" + rcEscape(rcWidgetTitle(widget)) + "</h3></div></div>" +
        '<div class="resource-list resource-list--grid" data-testid="resource-list-grid" data-has-recommendations="true">' + cards + "</div>" +
        "</div></div>"
    );
}

/* ---------- page detection + request ---------- */

// Containers on the page for one pattern: prefix_1, prefix_2 ... or the plain prefix
function rcFindContainersFor(pattern) {
    const found = [];
    let index = 1;
    while (document.getElementById(pattern.prefix + "_" + index)) {
        found.push({ elementId: pattern.prefix + "_" + index, pageType: pattern.pageType });
        index++;
    }
    if (!found.length && document.getElementById(pattern.prefix)) {
        found.push({ elementId: pattern.prefix, pageType: pattern.pageType });
    }
    return found;
}

function rcFindContainers() {
    let containers = [];
    RC_CONTAINER_PATTERNS.forEach(function (pattern) {
        containers = containers.concat(rcFindContainersFor(pattern));
    });
    return containers;
}

// Product page: id from the page's main <product-form-component> (the buy buttons; the quick-add forms inside
// product cards are skipped). Fallbacks: the container's own data-product-id, then Shopify's analytics object.
function rcProductId(containerEl) {
    const form = document.querySelector("product-form-component[data-product-id]:not(.quick-add__product-form-component)");
    if (form && form.dataset.productId) {
        return form.dataset.productId;
    }
    if (containerEl && containerEl.dataset.productId) {
        return containerEl.dataset.productId;
    }
    const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return meta && meta.id ? String(meta.id) : null;
}

// Cart page: product ids of the lines in the cart
function rcCartIds() {
    return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
            return (cart.items || []).map(function (item) { return String(item.product_id); });
        })
        .catch(function () { return []; });
}

// Collection page: top-level category name for the CATEGORY widgets (collection title, else the handle)
function rcCategoryName() {
    const heading = document.querySelector("h1");
    if (heading && heading.textContent.trim()) {
        return heading.textContent.trim();
    }
    const conf = window.UnbxdAnalyticsConf && window.UnbxdAnalyticsConf.page;
    const match = conf && String(conf).match(/category_handle(?:_uFilter)?:"([^"]+)"/);
    return match ? match[1].replace(/-/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : null;
}

// Resolves to the recommendation API URL for the page, or null when the page has nothing to request with
function rcBuildUrl(pageType, containerEl) {
    let url =
        "https://recommendations.unbxd.io/v3.0/" + getAPIKey() + "/" + getSiteName() + "/recommendation?template=false&pageType=" + encodeURIComponent(pageType) +
        "&fields=" + encodeURIComponent(RC_FIELDS.join(","));
    const finish = function () { return url + "&uid=" + encodeURIComponent(rcUserId()); };
    if (pageType === "PRODUCT") {
        const productId = rcProductId(containerEl);
        if (!productId) {
            return Promise.resolve(null);
        }
        url += "&id=" + encodeURIComponent(productId);
    } else if (pageType === "CATEGORY") {
        const name = rcCategoryName();
        if (!name) {
            return Promise.resolve(null);
        }
        url += "&catlevel1Name=" + encodeURIComponent(name);
    } else if (pageType === "CART") {
        return rcCartIds().then(function (ids) {
            ids.forEach(function (cartId) { url += "&id=" + encodeURIComponent(cartId); });
            return finish();
        });
    }
    return Promise.resolve(finish());
}

/* ---------- render ---------- */

// Widget N goes into container N; extra widgets reuse the last container
function rcRenderWidgets(data, containers, pageType) {
    const widgets = (data && data.response && data.response.widgets) || [];
    const requestId = (data && data.recsMetaData && data.recsMetaData.requestId) || rcUserId();
    widgets.forEach(function (widget, index) {
        const container = containers[Math.min(index, containers.length - 1)];
        const el = container && document.getElementById(container.elementId);
        const html = el ? rcWidgetHtml(widget, { widgetId: widget.widgetId, pageType: pageType, requestId: requestId }) : "";
        if (html) {
            el.innerHTML = html;
        }
    });
    // Judge.me draws the ratings for badges that were present at load; ask it to pick up the new ones
    try {
        if (window.jdgm && typeof window.jdgm.customizeBadges === "function") {
            window.jdgm.customizeBadges();
        }
    } catch (e) {
        /* ratings simply stay as the feed rendered them */
    }
}

// Requests the widgets for one page type and draws them into its containers
function rcFetchAndRender(pageType, containers) {
    return rcBuildUrl(pageType, document.getElementById(containers[0].elementId))
        .then(function (url) {
            return url ? fetch(url).then(function (response) {
                if (!response.ok) {
                    throw new Error("HTTP " + response.status);
                }
                return response.json();
            }) : null;
        })
        .then(function (data) {
            if (data) {
                rcRenderWidgets(data, containers, pageType);
            }
        })
        .catch(function (error) {
            console.error("[Unbxd Recs] Error fetching recommendations:", error);
        });
}

function rcStart() {
    const containers = rcFindContainers();
    if (!containers.length) {
        return;
    }
    // One request per page type (a page normally has just one)
    const pageType = containers[0].pageType;
    rcFetchAndRender(pageType, containers.filter(function (container) { return container.pageType === pageType; }));
}

// Called by the search bundle after it draws the no-results message (see unxNoResultsTemplate in unbxd_search.js)
window.unbxdRecsRenderNoResults = function () {
    const containers = rcFindContainersFor(RC_NO_RESULTS_PATTERN);
    if (containers.length) {
        rcFetchAndRender(RC_NO_RESULTS_PATTERN.pageType, containers);
    }
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rcStart);
} else {
    rcStart();
}

